const theme = {
  'primaryColor': '#219653',
  'globalHeader': {
    'headerIcon': 'arrow',
  }
}

export { theme }
